import { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Header from "./Header";
import Footer from "./Footer";
import tokenomicsShellStyle from "../styles/tokenomicsShellStyle";
import SeoHead from "../components/SeoHead";
import HeroInteractive from "../components/HeroInteractive";

const STATUS_LINES = [
  "Matchmaking servers warming up",
  "Fair-play checks online",
  "Reward rails syncing",
  "Agentic game agents booting",
  "Launch window locking in",
];

const GamingComingSoon = () => {
  const [energy, setEnergy] = useState(12);
  const [statusIndex, setStatusIndex] = useState(0);
  const [toast, setToast] = useState(null);

  const ping = useCallback((message) => {
    setEnergy((value) => Math.min(100, value + 8));
    setStatusIndex((i) => (i + 1) % STATUS_LINES.length);
    if (message) {
      setToast(message);
      window.setTimeout(() => setToast(null), 1400);
    }
  }, []);

  return (
    <div className="tokenomics-shell" style={tokenomicsShellStyle}>
      <SeoHead
        title="Atheriam Gaming - Coming Soon"
        description="Atheriam gaming is on the way - immersive worlds, fair play, and experiences powered by $ATH."
        path="/gaming"
      />
      <Header />

      <main className="gaming-soon">
        <section className="gaming-soon__hero">
          <div className="gaming-soon__copy">
            <p className="gaming-soon__brand">ATHERIAM</p>
            <h1 className="gaming-soon__title">
              Gaming
              <span> Coming Soon</span>
            </h1>
            <p className="gaming-soon__lede">
              New playable worlds are almost ready. Spin the wheel, feel the
              energy, and stay close for the real launch.
            </p>

            <div className="gaming-soon__meter" aria-label="Lobby energy">
              <div className="gaming-soon__meter-top">
                <span>Lobby energy</span>
                <strong>{energy}%</strong>
              </div>
              <div className="gaming-soon__meter-track">
                <motion.div
                  className="gaming-soon__meter-fill"
                  animate={{ width: `${energy}%` }}
                  transition={{ type: "spring", stiffness: 120, damping: 18 }}
                />
              </div>
            </div>

            <button
              type="button"
              className="gaming-soon__status"
              onClick={() => ping("Signal boosted")}
            >
              {STATUS_LINES[statusIndex]}
            </button>

            <div className="gaming-soon__actions">
              <Link to="/ico" className="gaming-soon__btn gaming-soon__btn--primary">
                Join ICO Waitlist
              </Link>
              <Link to="/whitepaper" className="gaming-soon__btn gaming-soon__btn--ghost">
                Read Whitepaper
              </Link>
              <Link to="/" className="gaming-soon__btn gaming-soon__btn--ghost">
                Back to Home
              </Link>
            </div>
          </div>

          <div
            className="gaming-soon__stage"
            onClick={() => ping("Wheel charged")}
          >
            <HeroInteractive />
          </div>
        </section>
      </main>

      <AnimatePresence>
        {toast ? (
          <motion.div
            className="gaming-soon__toast"
            initial={{ opacity: 0, y: 16, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.96 }}
            transition={{ duration: 0.25 }}
          >
            {toast}
          </motion.div>
        ) : null}
      </AnimatePresence>

      <Footer />
    </div>
  );
};

export default GamingComingSoon;
